// extracted by mini-css-extract-plugin
export var actions = "_a9-8";
export var arrow = "_a9-5";
export var card = "_a9-0";
export var cardWrapper = "_a9-9";
export var fieldName = "_a9-3";
export var newValue = "_a9-6";
export var oldValue = "_a9-4";
export var orangeGlowFade = "_a9-c";
export var productSection = "_a9-1";
export var scrollToBottom = "_a9-b";
export var scrollToBottomAnchor = "_a9-a";
export var scrollToBottomIcon = "_a9-d";
export var showAllButton = "_a9-7";
export var table = "_a9-2";